module.exports = __webpack_public_path__ + "assets/img/activity-raiders.c72a848d.png";